import clsx from 'clsx'

export type MascotPose =
  | 'camera' | 'charts' | 'checkmark' | 'chef' | 'clapping' | 'clipboard'
  | 'drinkingwater' | 'flexing' | 'holdingveggies' | 'hug' | 'jumping'
  | 'neutral' | 'notifications' | 'pill' | 'pointingright' | 'reading'
  | 'sad' | 'shrugging' | 'sleeping' | 'stethoscope' | 'streak' | 'thinking'
  | 'thirsty' | 'thumbsup' | 'waterdrop' | 'waving' | 'weight' | 'wink'
  | 'worried' | 'yummy'

type Continuous = 'none' | 'float' | 'sway' | 'pulse'

/** The Liverly mascot (PNG poses copied from the app's assets/mascot). */
export function Mascot({
  pose,
  size = 120,
  animation = 'float',
  className,
}: {
  pose: MascotPose
  size?: number
  animation?: Continuous
  className?: string
}) {
  return (
    <img
      src={`/mascot/${pose}.png`}
      alt=""
      aria-hidden
      width={size}
      height={size}
      className={clsx(
        'select-none object-contain',
        animation === 'float' && 'animate-float',
        animation === 'sway' && 'animate-sway',
        animation === 'pulse' && 'animate-pulse-soft',
        className,
      )}
      style={{ width: size, height: size }}
      draggable={false}
    />
  )
}
